import {Deal} from "./Deal";

export class EcommerceAction {
    constructor({
                    //attributes
                    id= null,
                    client_id= null,
                    product_id= null,
                    deal_id= null,
                    value= '',
                    action= '',
                    url = '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    deal = null,
                    product = null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.client_id=client_id;
        this.product_id=product_id;
        this.deal_id=deal_id;
        this.value=value;
        this.action=action;
        this.url=url;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;


        this.deal=new Deal(deal||{});
        this.product=product || {};

    }
}

export function createEcommerceAction(data={}) {
    return Object.freeze(new EcommerceAction(data));
}